import React, { ReactNode } from 'react';
import { Stack, Typography } from '@mui/material';
import { ArrowRightAlt } from '@mui/icons-material';

interface FieldChangeProps {
  label?: string;
  before: ReactNode;
  after: ReactNode;
}

export const FieldChange = ({ label, before, after }: FieldChangeProps) => (
  <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
    {label && <Typography>{label}:</Typography>}
    <Typography color="error.main" sx={{ textDecoration: 'line-through' }}>
      {before ?? '—'}
    </Typography>

    <ArrowRightAlt />

    <Typography color="success.main">{after ?? '—'}</Typography>
  </Stack>
);
